import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
import { ShieldCheck, TrendingDown, ClipboardList, MapPin, CircleCheck, Map, Users, Bell, Gauge, Clock, Wrench, FileText, Cloud, ChevronRight } from "lucide-react";
const leftFeatures = [{
  icon: <ShieldCheck className="w-6 h-6 text-primary" />,
  title: "DESPLIEGUE FLEXIBLE",
  desc: "Opciones de alojamiento local o en la nube disponibles."
}, {
  icon: <TrendingDown className="w-6 h-6 text-primary" />,
  title: "SIN CUOTAS POR USUARIO",
  desc: "Pague por llamada simultánea, no por extensión."
}, {
  icon: <ClipboardList className="w-6 h-6 text-primary" />,
  title: "FUNCIONES AVANZADAS",
  desc: "Colas de llamadas, IVR e informes avanzados incluidos."
}, {
  icon: <MapPin className="w-6 h-6 text-primary" />,
  title: "CONECTIVIDAD GLOBAL",
  desc: "Conecte oficinas remotas y trabajadores móviles fácilmente."
}];
const darkBoxFeatures = ["Transcripción de llamadas con IA avanzada", "Análisis de sentimiento inteligente", "Respuesta de voz automatizada (IVR)", "Integración con CRM y MS Teams", "Analítica de rendimiento en tiempo real", "Cifrado seguro de extremo a extremo"];
const bottomIcons = [{
  icon: <Map className="w-8 h-8 mb-2 text-primary" />,
  label: "SOPORTE\nOMNICANAL"
}, {
  icon: <Users className="w-8 h-8 mb-2 text-primary" />,
  label: "VIDEO\nCONFERENCIA"
}, {
  icon: <Bell className="w-8 h-8 mb-2 text-primary" />,
  label: "NOTIFICACIONES\nINTELIGENTES"
}, {
  icon: <Gauge className="w-8 h-8 mb-2 text-primary" />,
  label: "PANELES EN\nTIEMPO REAL"
}, {
  icon: <Clock className="w-8 h-8 mb-2 text-primary" />,
  label: "GRABACIÓN DE\nLLAMADAS"
}, {
  icon: <Wrench className="w-8 h-8 mb-2 text-primary" />,
  label: "GESTIÓN\nSENCILLA"
}, {
  icon: <FileText className="w-8 h-8 mb-2 text-primary" />,
  label: "REGISTROS\nDETALLADOS"
}, {
  icon: <Cloud className="w-8 h-8 mb-2 text-primary" />,
  label: "ALOJAMIENTO\nEN LA NUBE"
}];
export default function Hero3cxEnterprise() {
  return <section data-section-id="257908" id="hero-3cx-enterprise" className="bg-background text-foreground py-8 px-4 md:px-8 lg:py-12">
      <div className="max-w-[1200px] mx-auto">
        <div className="bg-card rounded-lg shadow-xl overflow-hidden border border-border flex flex-col">
          
          <div className="grid grid-cols-1 lg:grid-cols-12 p-6 md:p-10 gap-8 lg:gap-12 bg-gradient-to-br from-muted/50 to-background">
            
            <div className="lg:col-span-5 flex flex-col justify-center space-y-8">
              <div className="space-y-2">
                <Link to="/">
                  <WvcLogo className="h-10 mb-6 w-auto" />
                </Link>
                <h1 className="font-default text-4xl md:text-5xl font-bold text-primary tracking-tight uppercase">
                  Sistema Telefónico Empresarial con IA
                </h1>
                <h2 className="font-default text-xl md:text-2xl font-bold text-secondary uppercase tracking-wide">
                  Sin Precios de Empresa
                </h2>
                <p className="text-foreground font-medium text-lg mt-2">
                  Despliegue Flexible. Sin Cuotas por Usuario. Comunicaciones Inteligentes.
                </p>
              </div>

              <div className="space-y-5">
                {leftFeatures.map((feature, i) => <div key={i} data-index={i} className="flex items-start gap-4">
                    <div className="mt-1 bg-accent p-2 rounded-md shrink-0">
                      {feature.icon}
                    </div>
                    <div>
                      <h3 className="font-default font-bold text-primary text-sm leading-tight">
                        {feature.title}
                      </h3>
                      <p className="text-muted-foreground text-sm leading-snug mt-0.5">
                        {feature.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="lg:col-span-7 relative flex flex-col md:flex-row gap-6 items-stretch">
              
              <div className="bg-primary text-primary-foreground rounded-lg p-6 md:p-8 flex-1 z-10 shadow-lg flex flex-col justify-center">
                <h3 className="font-default text-xl font-bold mb-6 uppercase leading-tight">
                  Comunicación IA Potente<br />
                  <span className="text-secondary-foreground opacity-90">Impulsada por 3CX</span>
                </h3>
                <ul className="space-y-4">
                  {darkBoxFeatures.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                      <CircleCheck className="w-5 h-5 text-secondary-foreground shrink-0 mt-0.5" />
                      <span className="text-sm md:text-base leading-snug">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="flex-1 relative min-h-[300px] md:min-h-full flex items-center justify-center bg-muted/30 rounded-lg overflow-hidden p-4">
                <div className="relative w-full max-w-[300px] aspect-[4/5]">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/3cx_phone_app_interface.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/3cx_phone_app_interface.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685354/img/3cx_phone_app_interface.png-wvc-sizes" alt="Interfaz de la aplicación móvil 3CX" className="absolute inset-0 w-full h-full object-contain z-20 drop-shadow-2xl" loading="lazy" />
                  <div className="absolute top-1/3 -right-8 md:-right-16 bg-card text-card-foreground p-3 rounded-md shadow-xl z-30 border border-border max-w-[160px] hidden sm:block">
                    <div className="flex items-center gap-2 mb-1">
                      <Cloud className="w-4 h-4 text-secondary" />
                      <span className="font-default font-bold text-xs uppercase">Listo para la Nube</span>
                    </div>
                    <p className="text-[10px] text-muted-foreground leading-tight">
                      Su oficina telefónica, en cualquier parte del mundo.
                    </p>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className="border-t border-border bg-muted/10 p-6 md:p-8">
            <h4 className="font-default text-center text-sm font-bold text-primary uppercase tracking-wider mb-6">
              Visibilidad y Control Total de las Comunicaciones
            </h4>
            <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-8 gap-4 md:gap-2">
              {bottomIcons.map((item, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center group">
                  <div className="bg-background p-3 rounded-md shadow-sm border border-border mb-3 group-hover:border-primary transition-colors">
                    {item.icon}
                  </div>
                  <span className="text-[10px] md:text-xs font-bold text-foreground uppercase whitespace-pre-line leading-tight">
                    {item.label}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="bg-secondary text-secondary-foreground text-center py-3 px-4">
            <p className="font-default font-bold text-sm md:text-base tracking-wide uppercase">
              Ayudándole a mantenerse <span className="text-primary-foreground">conectado, eficiente y en control.</span>
            </p>
          </div>

          <div className="bg-background p-4 md:p-6 flex flex-col lg:flex-row items-center justify-between gap-6 border-t border-border">
            <div className="flex flex-col sm:flex-row gap-4 w-full lg:w-auto">
              <Button size="lg" className="w-full lg:w-auto font-bold uppercase tracking-wide group bg-primary hover:bg-primary/90 text-primary-foreground">
                Comience su Prueba Gratuita
                <ChevronRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" />
              </Button>
              <Button variant="outline" size="lg" className="w-full lg:w-auto font-bold uppercase tracking-wide border-primary text-primary hover:bg-accent">
                Ver Funciones
              </Button>
            </div>

            <div className="flex-1 text-center lg:text-right">
              <p className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
                Soluciones de comunicación inteligente para su negocio
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}